import { CloseButton, TextInput as MantineTextInput, type TextInputProps as MantineTextInputProps } from '@mantine/core'
import { useMergedRef } from '@mantine/hooks'
import { forwardRef, useCallback, useRef } from 'react'

export interface TextInputProps extends MantineTextInputProps {
  clearable?: boolean
}

export const TextInput = forwardRef<HTMLInputElement, TextInputProps>(
  ({ clearable, rightSection, size, unstyled, value, ...props }, forwardedRef) => {
    const inputRef = useRef<HTMLInputElement>()
    // @ts-ignore
    const ref = useMergedRef(inputRef, forwardedRef)
    const handleClear = useCallback(() => {
      // @ts-ignore solution for this found at https://stackoverflow.com/a/46012210
      Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, 'value').set.call(inputRef.current, '')

      inputRef.current?.dispatchEvent(new Event('input', { bubbles: true }))
    }, [])

    return (
      <MantineTextInput
        mb='xs'
        radius='md'
        ref={ref}
        rightSection={
          rightSection ||
          (value && clearable && (
            <CloseButton
              onClick={handleClear}
              size={size}
              unstyled={unstyled}
              variant='transparent'
            />
          ))
        }
        value={value}
        {...props}
      />
    )
  }
)

TextInput.displayName = 'TextInput'
